module.exports = __webpack_public_path__ + "static/media/4.0d6d2f2e.jpg";